module.exports = __webpack_public_path__ + "img/img (20).c11acfa2.jpg";